/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ILdsCartIcon containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum cartLinesSortOrder {
    ascending = 'ascending',
    descending = 'descending'
}

export interface ILdsCartIconConfig extends Msdyn365.IModuleConfig {
    imageSettings?: Msdyn365.IImageSettings;
    enableHoverCart?: boolean;
    cartLinesSortOrder?: cartLinesSortOrder;
    isAnonymousCheckout?: boolean;
}

export interface ILdsCartIconResources {
    goToCartButtonTitle: string;
    totalPriceFormatString: string;
    guestCheckoutButtonTitle: string;
    checkoutButtonTitle: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeConfiguration: string;
    quantityDisplayText: string;
    removeCartButtonText: string;
    cartLabel: string;
    cartQtyLabel: string;
    flyoutTitle: string;
}

export interface ILdsCartIconProps<T> extends Msdyn365.IModule<T> {
    resources: ILdsCartIconResources;
    config: ILdsCartIconConfig;
}
